import { SharedConstants } from "../../../../../shared/constants/shared.constants";
export class CreateApplicationDetailsPvConstants {
    static STEP_TITLE = "Details";
    static DESCRIPTION_LABEL = "Description";
    static DESCRIPTION_FORM_CONTROL_NAME = "description";
    static VALUATION_ROLL_SELECT_LABEL = "Valuation roll";
    static VALUATION_ROLL_SELECT_FORM_CONTROL_NAME = "valuationRollSelect";
    static VALUATIONBLOCK_METHOD_SELECT_LABEL = "Valuation method";
    static VALUATIONBLOCK_METHOD_SELECT_FORM_CONTROL_NAME = "valuationBlockMethodSelect";
    static PROPERTY_TYPE_SELECT_LABEL = "Property type";
    static PROPERTY_TYPE_SELECT_FORM_CONTROL_NAME = "propertyTypeSelect";
    static IMPLEMENTATION_DATE_LABEL = "Implementation date";
    static IMPLEMENTATION_DATE_FORM_CONTROL_NAME = "implementationDate";
    static VALUATION_REASON_LABEL = "Valuation reason";
    static VALUATION_REASON_FORM_CONTROL_NAME = "valuationReason";
    static VALUATION_BLOCK_DETAILS_FORM_CONTROL_NAME = "Valuation block details";
    static VALUATION_BLOCK_SPLIT_METHOD_FORM_NAME = "valuationSplitMethodForm";
    static VALUATION_BLOCK_SPLIT_METHOD_FORM_CONTROL_NAME = "valuationSplitMethodControlName";
    static HYBRID_METHODS = "Hybrid methods";
    static VALIDATION_MESSAGES = {
        description: {
            required: `Description ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        valuationRoll: {
            required: `Valuation roll ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        valuationMethod: {
            required: `Valuation method ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        property: {
            required: `Property type ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        implementationDate: {
            required: `Implementation date ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        fromDate: {
            required: `From date ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        }
    };
}
